import React, { memo, useCallback } from 'react';
import { Avatar, Box, Typography } from '@mui/material';

import StyledSubmitButton from '../../../../../components/Shared/StyledSubmitButton';
import { TCountry } from '../../../../../store/countries/countries.types';

import WrongCountryProduct from './WrongCountryProduct';

export interface IChangeMarketplaceFlowProps {
  productName: string;
  country: TCountry;
  onChangeProduct: (countryId: number) => void;
}

const ChangeMarketplaceFlow = ({ productName, country, onChangeProduct }: IChangeMarketplaceFlowProps): JSX.Element => {
  const goToMarketplace = useCallback(() => {
    onChangeProduct(country.id);
  }, [onChangeProduct, country]);

  return (
    <>
      <WrongCountryProduct productName={productName} countryName={country.name}>
        <Typography className="Subcopy-Static">Do you want to select a gift from your local marketplace?</Typography>
      </WrongCountryProduct>
      <StyledSubmitButton
        onClick={goToMarketplace}
        data-testid="ShippingAddressForm.GoToMarketplaceButton"
        width="100%"
      >
        <Box mr={2}>
          <Avatar src={country.image} />
        </Box>
        {country.name} Marketplace
      </StyledSubmitButton>
    </>
  );
};

export default memo<IChangeMarketplaceFlowProps>(ChangeMarketplaceFlow);
